import './BadgePro.scss';

const BadgePro = ({ icon, onlyIcon = false }) => (
  <div className={`badge-pro-container ${onlyIcon && 'p-1'}`}>
    {icon}
    <p className={`badge-pro-text ${onlyIcon && 'd-none'}`}>PRO</p>
  </div>
);

export default BadgePro;
